import { Col, Row, Spin } from "antd";
import { EstatusIcon } from "./_EstatusIcon";

//
export const MostrarListaDocumentos = ({ listaDacumentos, loading, setListaDocumentos }) => {
  if (!listaDacumentos || listaDacumentos.length === 0) return <></>;

  return (
    <>
      {loading && <Spin />}
      <p>Archivos Evaluados: {listaDacumentos.length} - <span onClick={()=> setListaDocumentos([])} className="link">Limpiar Lista</span></p>


      {listaDacumentos.map((ld, index) => (
        <Row>
          <Col span={1} className="columna">
            {index + 1}
          </Col>
          <Col span={8} className="columna">
            {ld.name}
          </Col>
          <Col span={1} className="columna">
            <EstatusIcon ld={ld} />
          </Col>
          <Col span={6} className="columna">
            {ld.msg}
          </Col>
        </Row>
      ))}
    </>
  );
};
